import LoginForm from "../../components/auth/LoginForm";
import logo from "../../images/logo.png";
import auth from '../../components/auth/AuthForms.module.css';


const LoginPage = () => {
    return (
        <main className={`${auth.login} text-white`}>
            <div className={auth.loginContent}>
                <section className={auth.loginText}>
                    <h1 id="bienvenida" className="m-0">
                        Reserva <span className={auth.highlight}>fácil</span> e infórmate del estado y disponibilidad de cada equipo de nuestro: Centro de Operaciones y Logística <span className={auth.highlightGreen}>(COL)</span> de Ecoturismo.
                    </h1>
                </section>
                <section className={auth.loginForm}>
                    <LoginForm />
                </section>
            </div>
            <img
                className={auth.loginLogo}
                src={logo}
                alt="Logo"
            />
        </main>
    );
};
export default LoginPage;